"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBalanceStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useBalanceStore = (0, pinia_1.defineStore)('balanceStore', {
    state: () => ({
        balance: null
    }),
    actions: {
        async getBalance(router, params = {}) {
            const response = await (0, fetch_1.default)(router.resolve({ name: 'axapta_balance_api', params }).href);
            this.balance = response;
            return response;
        },
        reset() {
            this.balance = null;
        }
    }
});
